/* eslint-disable max-len */
import React from 'react';

export default function TiktokIcon() {
    return (
        <svg width="24px" height="28px" viewBox="0 0 24 28">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="1946538" fill="#000000" fillRule="nonzero">
                    <path d="M23.1959518,6.15042116 C20.3151981,6.15042116 17.9715233,3.75933841 17.9715233,0.8203125 C17.9715233,0.367218031 17.6115861,0 17.1674751,0 L12.861211,0 C12.4173094,0 12.0571628,0.367218031 12.0571628,0.8203125 L12.0571628,18.8325806 C12.0571628,20.5603638 10.6791834,21.9660034 8.98565693,21.9660034 C7.29213049,21.9660034 5.91436052,20.5603638 5.91436052,18.8325806 C5.91436052,17.1045837 7.29213049,15.6989441 8.98565693,15.6989441 C9.42976794,15.6989441 9.78970509,15.331726 9.78970509,14.8786316 L9.78970509,10.48526 C9.78970509,10.0323792 9.42976794,9.66494752 8.98565693,9.66494752 C4.03091957,9.66494752 0,13.7776184 0,18.8325806 C0,23.8875427 4.03091957,28 8.98565693,28 C13.9403943,28 17.9715233,23.8875427 17.9715233,18.8325806 L17.9715233,10.8595276 C19.5716629,11.7300415 21.3525039,12.1844177 23.1959518,12.1844177 C23.6400628,12.1844177 24,11.8171997 24,11.3641052 L24,6.97073366 C24,6.5178528 23.6400628,6.15042116 23.1959518,6.15042116 Z" />
                </g>
            </g>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/view/my-store/components/icons/TiktokIcon.js